import * as React from 'react';
import { useDispatch } from 'react-redux';

import { useFiltersContext } from '../../../../packages/Filters/shared/utils/useFiltersContext';
import { resetTerms } from '../../../../packages/JsonQuery';
import { justChangeJsonQuery } from '../../../common/actions/filters/justChangeJsonQuery';
import { useActiveFilters } from '../../../common/hooks/useActiveFilters';
import { TThunkDispatch } from '../../../common/types/redux';
import { getResettableFilters } from '../../../common/utils/getResettableFilters';
import { EmptyListing } from '../../components/EmptyListing';

interface IEmptyListingContainerProps {
  onShow: () => void;
}

// Контейнер пустой выдачи на десктопе: показ и сброс завязаны на один список пользовательских фильтров
export const EmptyListingContainer = ({ onShow }: IEmptyListingContainerProps) => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { jsonQuery, onApply } = useFiltersContext();
  const { hasActiveFilters, hasExtraFilters } = useActiveFilters();

  const onResetAllFilters = React.useCallback(() => {
    // Получаем все фильтры, которые можно сбросить
    const resettableFilters = getResettableFilters(jsonQuery);

    if (resettableFilters.length > 0) {
      // Сбрасываем все фильтры кроме исключенных
      const nextJsonQuery = resetTerms(resettableFilters)(jsonQuery);
      dispatch(justChangeJsonQuery({ nextJsonQuery }));
      onApply();
    }
  }, [dispatch, jsonQuery, onApply]);

  return <EmptyListing onShow={onShow} showReset={hasActiveFilters || hasExtraFilters} onReset={onResetAllFilters} />;
};
